module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar additionalClasses   = [];\nvar nrOfElements        = Object.keys(model.entityList || {}).length\nvar isEmpty             = nrOfElements <= 0;\nif(isEmpty)                         additionalClasses.push('emptyTable');\nif(config.showHead)                 additionalClasses.push('showHead');\nif(config.inline)                   additionalClasses.push('inlineTable');\nif(config.supportLazyloading)       additionalClasses.push('supportLazyloading');\nif(config.showAllBorders)           additionalClasses.push('showAllBorders');\nif(config.showDelimiterBorders)     additionalClasses.push('showDelimiterBorders');\nif(config.showScrollBarAnyway)      additionalClasses.push('showScrollBarAnyway');\nif(config.showColorCodedRows)       additionalClasses.push('showColorCodedRows');\nif(config.usage)                    additionalClasses.push(`usage_${config.usage}`);\nif(config.sortByDragging)           additionalClasses.push('sortByDragging');\nvar tableHeadTitleKey = 'table.head.' + (config.buttonContext || 'default');\nif(config.usage === 'selection' && config.isSelectionTarget){\ntableHeadTitleKey = 'table.head.selection.' + (config.buttonContext || 'default');\n}\nvar rowIndex = 0;\nconfig.maxRowIndex = 0\nfor(var f in model.fields){\nif((model.fields[f].config || {}).rowIndex > 0){\nconfig.maxRowIndex = Math.max(config.maxRowIndex, model.fields[f].config.rowIndex)\n}\n}\nif(config.maxRowIndex > 0) additionalClasses.push('multiline');\n%>\n<div class=\"<%- additionalClasses.join(' ') %>\">\n<%\nif(!config.preventRender && (!config.renderEmptyBeforReady || config.isReady)){\nif(config.showHead){\n%>\n<section class=\"head\">\n<h2><%= __(tableHeadTitleKey); %></h2>\n<%\nif(config.showInsertButton){\n%><%- include('../form/elements/buttons', { formMapping: { buttons: [{ buttonType: 'showInsert', context: config.buttonContext, positive: true }] } }) %><%\n}\n%>\n</section>\n<%\n}\n%>\n<table cellpadding=\"0\" cellspacing=\"0\">\n<%\nif(model.fields){\nvar headConfig = utils.simpleCopy(config);\nheadConfig.isHead = true;\n%><%- include('./row', { config: headConfig, model: model }); %><%\n}\nif(model.entityList){\nvar e;\nfor(e in model.entityList || {}){\nif((model.entityList[e].meta || {}).hasGroupRow){\n%><%- include('./groupRow', { config: config, resourceData: model.entityList[e], model: model }); %><%\n}\n%><%- include('./row', { config: config, resourceData: model.entityList[e], model: model }); %><%\n}\n}\nif(isEmpty){\n%>\n<tbody>\n<tr>\n<td class=\"emptyTableMessage\">\nKeine Datensätze vorhanden\n</td>\n</tr>\n</tbody>\n<%\n}\n%>\n</table>\n<%\nif(config.supportLazyloading && !isEmpty){\n%><%- include('../form/elements/buttons', { formMapping: { buttons: [{ buttonType: 'lazyload', context: config.buttonContext }] } }) %><%\n}\n}\n%>\n</div>"
  , __filename = "node_modules/frontend-controller/baseComponents/tableSimple/table.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var additionalClasses   = [];
var nrOfElements        = Object.keys(model.entityList || {}).length
var isEmpty             = nrOfElements <= 0;
if(isEmpty)                         additionalClasses.push('emptyTable');
if(config.showHead)                 additionalClasses.push('showHead');
if(config.inline)                   additionalClasses.push('inlineTable');
if(config.supportLazyloading)       additionalClasses.push('supportLazyloading');
if(config.showAllBorders)           additionalClasses.push('showAllBorders');
if(config.showDelimiterBorders)     additionalClasses.push('showDelimiterBorders');
if(config.showScrollBarAnyway)      additionalClasses.push('showScrollBarAnyway');
if(config.showColorCodedRows)       additionalClasses.push('showColorCodedRows');
if(config.usage)                    additionalClasses.push(`usage_${config.usage}`);
if(config.sortByDragging)           additionalClasses.push('sortByDragging');
var tableHeadTitleKey = 'table.head.' + (config.buttonContext || 'default');
if(config.usage === 'selection' && config.isSelectionTarget){
tableHeadTitleKey = 'table.head.selection.' + (config.buttonContext || 'default');
}
var rowIndex = 0;
config.maxRowIndex = 0
for(var f in model.fields){
if((model.fields[f].config || {}).rowIndex > 0){
config.maxRowIndex = Math.max(config.maxRowIndex, model.fields[f].config.rowIndex)
}
}
if(config.maxRowIndex > 0) additionalClasses.push('multiline');

    ; __line = 27
    ; __append("\n<div class=\"")
    ; __line = 28
    ; __append( additionalClasses.join(' ') )
    ; __append("\">\n")
    ; __line = 29
    ; 
if(!config.preventRender && (!config.renderEmptyBeforReady || config.isReady)){
if(config.showHead){

    ; __line = 32
    ; __append("\n<section class=\"head\">\n<h2>")
    ; __line = 34
    ; __append(escapeFn( __(tableHeadTitleKey) ))
    ; __append("</h2>\n")
    ; __line = 35
    ; 
if(config.showInsertButton){

    ; __line = 37
    ; __append( include('../form/elements/buttons', { formMapping: { buttons: [{ buttonType: 'showInsert', context: config.buttonContext, positive: true }] } }) )
    ; 
}

    ; __line = 39
    ; __append("\n</section>\n")
    ; __line = 41
    ; 
}

    ; __line = 43
    ; __append("\n<table cellpadding=\"0\" cellspacing=\"0\">\n")
    ; __line = 45
    ; 
if(model.fields){
var headConfig = utils.simpleCopy(config);
headConfig.isHead = true;

    ; __line = 49
    ; __append( include('./row', { config: headConfig, model: model }) )
    ; 
}
if(model.entityList){
var e;
for(e in model.entityList || {}){
if((model.entityList[e].meta || {}).hasGroupRow){

    ; __line = 55
    ; __append( include('./groupRow', { config: config, resourceData: model.entityList[e], model: model }) )
    ; 
}

    ; __line = 57
    ; __append( include('./row', { config: config, resourceData: model.entityList[e], model: model }) )
    ; 
}
}
if(isEmpty){

    ; __line = 61
    ; __append("\n<tbody>\n<tr>\n<td class=\"emptyTableMessage\">\nKeine Datensätze vorhanden\n</td>\n</tr>\n</tbody>\n")
    ; __line = 69
    ; 
}

    ; __line = 71
    ; __append("\n</table>\n")
    ; __line = 73
    ; 
if(config.supportLazyloading && !isEmpty){

    ; __line = 75
    ; __append( include('../form/elements/buttons', { formMapping: { buttons: [{ buttonType: 'lazyload', context: config.buttonContext }] } }) )
    ; 
}
}

    ; __line = 78
    ; __append("\n</div>")
    ; __line = 79
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=node_modules/frontend-controller/baseComponents/tableSimple/table.ejs

}